import { Badge, SxProps, Theme } from '@mui/material';

import colors from '../../../../../constants/colors';

const SMARTtrekBadge = ({
  showMobile,
  sx,
}: {
  showMobile: boolean;
  sx?: SxProps<Theme>;
}) => {
  return (
    <Badge
      sx={{
        fontFamily: 'Cabin',
        fontKerning: 'normal',
        borderRadius: 1,
        background: colors.csaaNeutralBackground,
        py: 0.5,
        px: 1,
        fontWeight: 500,
        lineHeight: '16px',
        fontSize: 14,
        letterSpacing: 0.2,
        height: 'fit-content',
        width: 'fit-content',
        color: colors.csaaDark,
        display: {
          mobile: showMobile ? 'block' : 'none',
          tablet: showMobile ? 'none' : 'block',
        },
        ...sx,
      }}
    >
      SMART<i>trek</i>®
    </Badge>
  );
};

export default SMARTtrekBadge;
